import { render, staticRenderFns } from "./AlertMenu.vue?vue&type=template&id=32ff1f0c&scoped=true&"
import script from "./AlertMenu.vue?vue&type=script&lang=js&"
export * from "./AlertMenu.vue?vue&type=script&lang=js&"
import style0 from "./AlertMenu.vue?vue&type=style&index=0&id=32ff1f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff1f0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/www-purejs/EdsOnLineMobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VFlex,VLayout})
